import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { Browser } from '@syncfusion/ej2-base';

@Component({
  selector: 'app-navigation-topbar',
  templateUrl: './navigation-topbar.component.html',
  styleUrls: ['./navigation-topbar.component.scss'],
  imports: [LanguageSelectorComponent]
})
export class NavigationTopbarComponent implements OnInit {

  public playStoreUrl: string = environment.playStoreUrl;
  public appStoreUrl: string = environment.appStoreUrl;

  public get isAndroid(): boolean {
    return Browser.isAndroid;
  }

  public get isIos(): boolean {
    return Browser.isIos;
  }

  constructor() { }

  ngOnInit() {
  }

  public get version(): string {
    return environment.version;
  }

}
